import React from 'react'
import icon1 from '../../../assets/icon_1.png'
import icon2 from '../../../assets/icon_2.png'
import icon3 from '../../../assets/icon_3.png'
import icon4 from '../../../assets/icon_4.png'
import cl from 'classnames'

import './index.less'

function Advantage() {
  const itemArr = [
    {
      url: icon1,
      title: '海量粉丝',
      subTitle: '5亿+ 直播&短视频平台粉丝矩阵等',
    },
    {
      url: icon2,
      title: '知名主播',
      subTitle: '合作艺人40+、主播达人100+',
    },
    {
      url: icon3,
      title: '专业支持',
      subTitle: '品牌运营、商品运营、供应链、大数据全方位支持',
    },
    {
      url: icon4,
      title: '资本增值',
      subTitle: '上市企业，愿与合作伙伴共乘资本和直播的东风，携手遥望未来',
    },
  ]

  const Item = (props: any) => {
    const { info, number } = props
    const { url, title, subTitle } = info
    const isTrue = number === 3 || number === 4

    return (
      <div
        className={cl('item', {
          'item-more-height': isTrue
        })}
      >
        <img className="img-icon" src={url} alt="" />
        <div className="main-title">{title}</div>
        <div className="sub-title">{subTitle}</div>
      </div>
    )
  }

  return (
    <div className="advantage-wrapper">
      <div className="title">平台优势</div>
      <div className="item-wrapper">
        {itemArr.map((item, index) => {
          return <Item info={item} key={index} number={index + 1} />
        })}
      </div>
    </div>
  )
}

export default Advantage
